import cn from "../../lib/classnames";
import React from "react";
import styles from "./TextLink.module.css";
import textStyles from "../../styles/Text.module.css";
import {Link} from "react-router-dom";

type Props = {
    to?: string;
    href?: string;
    onClick?: () => void;
    text: string;
    className?: string;
    openInSameTab?: boolean;
    wrapLink?: boolean;
};

export default function TextLink(props: Props) {
    const classNames = cn(
        props.className,
        textStyles.link,
        styles.link,
        props.onClick ? styles.button : undefined,
        !props.wrapLink ? styles.noWrapLink : undefined,
    );

    if (props.to) {
        return (
            <Link
                to={props.to}
                className={classNames}
                target={props.openInSameTab ? undefined : "_blank"}
                rel="noopener noreferrer"
            >
                {props.text}
            </Link>
        );
    }

    if (props.href) {
        return (
            <a
                href={props.href}
                className={classNames}
                target={props.openInSameTab ? undefined : "_blank"}
                rel="noopener noreferrer"
            >
                {props.text}
            </a>
        );
    }

    return (
        <button onClick={props.onClick} className={classNames} type="button">
            {props.text}
        </button>
    );
}
